import { SideMediaAssetProps } from '@ahc-digital/component-library';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { C17SideMediaAssetProps } from './C17SideMediaAsset.types';

export function CreateSideMediaAssetModel(props?: C17SideMediaAssetProps): SideMediaAssetProps {
  const { fields, params } = props || {};

  type t = SideMediaAssetProps;

  const { renderText, renderRichText, renderLink, renderImage } = useConditionalRendering();

  return {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy, { required: true }),
    image: renderImage(fields?.Image),
    videoId: fields?.VideoId?.value,
    imageCaption: renderRichText(fields?.ImageCaption),
    imageCtaLink: renderLink(fields?.ImageCtaLink),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    imageSide: getDroplink<t['imageSide']>(params?.ImageSide, 'right'),
    isImageBorderOn: getCheckbox(params?.ImageBorderOn),
    imageContainerSize: getDroplink<t['imageContainerSize']>(params?.ImageContainerSize, 'fifty'),
    shouldLazyLoad: getCheckbox(params?.ShouldLazyLoad),
  };
}
